module.exports = __webpack_public_path__ + "img/tablo_hover_dcfe978.webp";